import React, { FormEvent, useEffect } from 'react';
import styled from '@emotion/styled';
import { LocalStorage } from '@vromo/models';
import { useLocalObservable, observer } from 'mobx-react-lite';
import { passwordCheck } from '@vromo/ui';
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom';

const tagManagerArgs = {
    gtmId: 'GTM-W6HJBKK'
}

const Input = styled.input`
    padding: 10px;
    font-size: 16px;
    border-radius: 5px;
    border: 1px solid #eee;
    -webkit-appearance: none;
    display: block;
    margin: 4px;

    &::placeholder {
        color: #ccc;
    }
`;

const Button = styled.button`
    background-color: rgb(255, 176, 46);
    color: white;
    text-align: center;
    padding: 8px;
    border-style: none;
    transition: background-color 0.2s ease-in-out 0s;
    cursor: pointer;
    font-size: 16px;
    font-weight: 400;
    border-radius: 3px;
    margin: 4px;
    display: block;

    &:hover {
        background-color: rgb(245, 168, 44);
    }
`;

const Error = styled.div`
    margin: 4px;
    text-align: center;
    background-color: rgba(255, 176, 46, 0.5);
    border: 1px solid rgb(255, 176, 46);
    padding: 8px;
    border-radius: 3px;
`;

export default observer(function SignUp() {
    const { search } = useLocation();

    useEffect(() => {
        const searchParams = new URLSearchParams(search);
        const utmVars: { [key: string]: string } = {};
        for (const [key, value] of searchParams) {
            if (/utm_/.test(key)) utmVars[key] = value;
        }
        LocalStorage.utmVars = utmVars;
    }, [search])

    const store = useLocalObservable(() => ({
        email: '',
        password: '',
        error: ''
    }));

    TagManager.initialize(tagManagerArgs)

    async function signUp(e: FormEvent) {
        e.preventDefault();

        const errors = passwordCheck(store.password, store.password);
        if (errors.length) {
            store.error = errors[0]?.message || '';
            return;
        }

        fetch(`https://edge-1-auth.vromo.io/v2/signup/freemium`, {
            method: 'POST',
            body: JSON.stringify({
                username: store.email,
                password: store.password,
            })
        }).then(async (response) => {
            const jsonRes = await response.json();
            if (response.ok) {
                const {
                    data: { tok }
                } = jsonRes;

                LocalStorage.isInitialSignup = true;
                if (window.top) window.top.location.href = `${window.location.origin}/auto-login?tok=${tok}`;
            } else {
                store.error = jsonRes.status.includes('password')
                    ? 'This password is insecure. Please choose a stronger password with a minimum of 8 characters.'
                    : 'This email is either forbidden or already taken. Try another.';
            }
        });
    }

    return (
        <form
            style={{ display: 'flex', flexDirection: 'column' }}
            onSubmit={signUp}
            id="signup_iframe_form"
        >
            {store.error ? <Error>{store.error}</Error> : null}
            <Input
                type="email"
                placeholder="Email address"
                value={store.email}
                onChange={(e) => (store.email = e.target.value)}
                required
            />
            <Input
                type="password"
                placeholder="Password"
                value={store.password}
                onChange={(e) => (store.password = e.target.value)}
                required
            />
            <Button type="submit">Sign Up</Button>
        </form>
    );
});
